/**
 * sellPayments
 * 卖币支付信息
 * 二次支付数据、创建订单、选择支付方式
 */

const state = {
    orderNo: '',
    // 订单支付方式信息
    sellPayType: {
        accountType: '', // 1-Bank Account、2-Credit Card
        payWayCode: '19000', // 19000-Bank Account、10010-Credit Card
    },
    // 订单支付信息
    sellPayInfo: {
        bankAccountInfo: {}, // Bank Account表单
        userAccountId: '', // 历史表单id
        // 信用卡表单
        firstName: '',
        lastName: '',
        accountNumber: '',
        phone: '',
        birthDate: '',
    }
}

const mutations = {
    //保存订单id
    set_orderNo(state, val) {
        state.orderNo = val;
    },
    set_sellPayType(state, val) {
        state.sellPayType = val;
    },
    set_sellPayInfo(state, val) {
        state.sellPayInfo = val;
    },
}

export default {
    namespaced: true,
    state,
    mutations
};
